import React from 'react';
import { ComponentPropsWithoutRef } from 'react';
import { cx } from '@linaria/atomic';
import { formatDate } from '../../../helpers/format-date';
import { CaretDownIconSmall } from '../../../icon/icons-small/caret-down-small';
import { CaretUpIconSmall } from '../../../icon/icons-small/caret-up-small';
import { NakedButton } from '../../../naked/naked-button.component';
import { Text } from '../../text/text.component';
import { SelectByType } from '../calendar-types';
import { CalendarControlsStyles } from '../layouts/dialog/styles';
import { useCalendarState } from '../provider/calendar.provider';
import { getDecadeRange } from '../provider/reducer/calendar-utils';
import type { BaseAtomProps } from './calendar-atom.types';

type Props = BaseAtomProps & {
  month: number;
  year: number;
};
type CalendarTitleProps = Props & Omit<ComponentPropsWithoutRef<'button'>, keyof Props>;

const formatTitle = (month: number, year: number, selectBy: SelectByType) => {
  switch (selectBy) {
    case 'day':
      return formatDate(new Date(year, month), 'MMMM YYYY');
    case 'month':
      return year;
    case 'year': {
      const decade = getDecadeRange(year);
      return `${decade[0]} - ${decade[decade.length - 1]}`;
    }
  }
};

export const CalendarTitle = ({ className, month, year, ...rest }: CalendarTitleProps) => {
  const { selectByBtnProps, selectBy } = useCalendarState();
  const titleHeader = CalendarControlsStyles.titleHeader;
  return (
    <React.Fragment>
      {selectBy !== 'year' ? (
        <NakedButton {...selectByBtnProps} className={titleHeader} type='button' {...rest}>
          <time dateTime={`${year}-${month}`} className={cx('cal__month-name', className)}>
            {formatTitle(month, year, selectBy)}
          </time>
          <span>
            <CaretUpIconSmall color='light' />
            <CaretDownIconSmall color='light' />
          </span>
        </NakedButton>
      ) : (
        <Text as='h4' weight='bold' className={cx('cal__month-name', className)}>
          {formatTitle(month, year, selectBy)}
        </Text>
      )}
    </React.Fragment>
  );
};
